import Layout, { Section, PageHero } from "@/components/layout/Layout";
import { Reveal } from "@/components/common/Reveal";

const stack = [
    { g: "Language", items: ["Localized LLMs", "Domain adaptation", "Evaluation harnesses", "Prompt libraries"] },
    { g: "Voice & Speech", items: ["Multilingual TTS", "Streaming STT", "Voice cloning (consented)", "Acoustic tuning"] },
    { g: "Agents", items: ["Planning graphs", "Tool orchestration", "Legibility layer", "Human-in-the-loop"] },
    { g: "Knowledge", items: ["Retrieval systems", "Vector search", "Structured memory", "Citations & provenance"] },
    { g: "Automation", items: ["Workflow engines", "Event routing", "Long-running jobs", "Observability"] },
    { g: "Inference", items: ["Multi-model routing", "Latency budgets", "Cost governance", "Edge & cloud"] },
    { g: "Multimodal", items: ["Vision-language", "Audio-language", "Document understanding", "Media pipelines"] },
];

export default function Technology() {
    return (
        <Layout title="Technology — Ventara" description="The quiet stack: LLMs, voice, agents, knowledge, automation, inference, multimodal.">
            <PageHero i18nKey="technology"
                eyebrow="Technology"
                title={<>The quiet stack.</>}
                lead="A layered set of building blocks that we combine into products and platforms. Every layer is designed to disappear — which is another way of saying, designed to be trusted."
            />

            <Section className="pb-32">
                <div className="grid lg:grid-cols-2 gap-x-12 gap-y-8">
                    {stack.map((s, idx) => (
                        <Reveal key={s.g} delay={(idx % 2) * 0.05}>
                            <div className="border-t border-border pt-8" data-testid={`tech-${s.g.toLowerCase().replace(/[^a-z0-9]/gi,'-')}`}>
                                <div className="flex items-baseline justify-between">
                                    <h3 className="font-serif text-3xl tracking-tight">{s.g}</h3>
                                    <span className="label">0{idx + 1}</span>
                                </div>
                                <ul className="mt-8 grid grid-cols-2 gap-y-4 gap-x-6">
                                    {s.items.map((it) => (
                                        <li key={it} className="prose-body text-sm flex items-center gap-3">
                                            <span className="inline-block w-1.5 h-1.5 rounded-full bg-foreground/50" />
                                            {it}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </Section>

            <Section className="py-24 border-t border-border">
                <div className="grid lg:grid-cols-3 gap-12">
                    {[
                        ["ISO 27001", "Security"],
                        ["SOC 2 Type II", "Compliance"],
                        ["GDPR & DPDP", "Privacy"],
                    ].map(([t, l]) => (
                        <div key={t}>
                            <div className="font-serif text-4xl">{t}</div>
                            <div className="label mt-2">{l}</div>
                        </div>
                    ))}
                </div>
            </Section>
        </Layout>
    );
}
